import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";

@Pipe({
    name: "applicationReviewStatus",
    standalone: false
})
export class ApplicationReviewStatusPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) { }

  transform(value: number): any {
    switch (value) {
      case 1:
        return 'Pending'
      case 2:
        return 'Started'
      case 3:
        return 'Completed'
      default:
        break;
    }
  }
}
